export class ImportacoesErro {
  constructor(
    public linha: number,
    public coluna: string,
    public erro: string,
    public mensagem: string
  ) { }
}
